<template>
	<div class="input-search-text-field">
		<v-text-field
			:placeholder="placeholder"
			class="srch rounded-lg"
			v-model="localValue"
			outlined
			hide-details
			ref="text-field"
			:height="height"
			dense
			color="#dfe4ef"
			background-color="white"
		>
			<template v-slot:prepend-inner>
				<v-icon>fa-search</v-icon>
			</template>
		</v-text-field>
	</div>
</template>

<script>
export default {
	name: 'InputSearchTextField',
	props: {
		value: { type: String },
		height: { type: Number },
		placeholder: { type: String, default: 'Search items' },
	},
	computed: {},
	data() {
		return {
			localValue: this.value,
		};
	},
	methods: {
		focus() {
			this.$nextTick(() => {
				this.$refs['text-field'].$refs.input.focus();
			});
		},
	},
	watch: {
		localValue: {
			handler(newV) {
				this.$emit('input', newV);
			},
		},
		value: {
			handler(newV) {
				this.localValue = newV;
			},
		},
	},
};
</script>
<style scoped lang="scss">
.input-search-text-field {
	::v-deep .v-text-field--outlined {
		fieldset {
			border-color: var(--border-color);
		}
		.v-icon {
			font-size: 14px;
			margin: 5px;
		}
	}
}
</style>
